<div class="horizontal-scroll" #container>
    <button [ngClass]="{ 'hidden': !showLeftButton }" (click)="scrollLeft()" class="scroll-button left">‹</button>
    <div class="carousel" #carousel (scroll)="onScroll()">
      <ng-content></ng-content>
    </div>
    <button [ngClass]="{ 'hidden': !showRightButton }" (click)="scrollRight()" class="scroll-button right">›</button>
  </div>
  